import { createContext, useState, useEffect } from "react";

import useApi from '@hooks/useApi';
import useLoader from '@hooks/useLoader';
// import { useNavigate } from "react-router-dom"

export const AuthContext = createContext();

export default function AuthContextProvider({ children }) {

    const [ userDetail, setUser ] = useState({})
    const [ logged, setLogged ] = useState(false)
    const [ loading, setLoading ] = useState(true);

    // const navigate = useNavigate()

    const userApi = useApi().user
    const { fetchData } = useLoader({})

    async function getUserData() {
        const { success, data } = await fetchData(userApi.firstCheckLogged())
        if(success)
        {
            setUser(data.data)
            setLogged(data.logged_user)
            setLoading(false);
        }
    }

    useEffect(
        () =>
        {
            getUserData()
        },
        []
    )

    return (
        <AuthContext.Provider
            value={{ userDetail, logged, setUser, setLogged }}
        >
            {loading ? null : children}
        </AuthContext.Provider>
    );
};
